import type { ModoCozinha, PlanoCardapio } from '../config/cardapio';

/** Restaurante cliente do produto (tenant). */
export interface RestauranteCardapio {
  id: string;
  /** Identificador na URL (?r=slug) */
  slug: string;
  nome: string;
  whatsapp: string;
  plano: PlanoCardapio;
  maxMesas: number;
  modoCozinha: ModoCozinha;
  /** Chave Pix do restaurante (configurável pelo dono). */
  chavePix: string;
  /** Senha do painel balcão/cozinha (hash simples ou texto — MVP local). */
  senhaPainel: string;
  /** Licença paga até (YYYY-MM-DD). Controle mensal do Ade. */
  pagoAte: string;
  ativo: boolean;
  criadoEm: string;
  /** Endpoint GAS futuro (opcional). */
  apiEndpoint?: string;
}

export type CategoriaItem = 'entrada' | 'prato' | 'bebida' | 'sobremesa' | 'outro';

export interface ItemCardapio {
  id: string;
  nome: string;
  descricao?: string;
  preco: number;
  categoria: CategoriaItem;
  /** Tempo estimado de preparo em minutos. */
  tempoPrepMin: number;
  ativo: boolean;
  ordem: number;
}

export type FormaPagamento = 'pix' | 'dinheiro' | 'cartao';
export type StatusPedido =
  | 'aguardando_pagamento'
  | 'pago'
  | 'enviado_cozinha'
  | 'preparando'
  | 'pronto'
  | 'entregue'
  | 'cancelado';

export interface ItemPedido {
  itemId: string;
  nome: string;
  quantidade: number;
  precoUnit: number;
  obs?: string;
}

export interface PedidoCardapio {
  id: string;
  restauranteSlug: string;
  mesa: number;
  itens: ItemPedido[];
  total: number;
  formaPagamento: FormaPagamento;
  status: StatusPedido;
  /** Cliente informou que pagou Pix. */
  clienteDissePagouPix?: boolean;
  criadoEm: string;
  atualizadoEm: string;
  tempoEstimadoMin?: number;
}

export const LABEL_CATEGORIA: Record<CategoriaItem, string> = {
  entrada: 'Entradas',
  prato: 'Pratos',
  bebida: 'Bebidas',
  sobremesa: 'Sobremesas',
  outro: 'Outros',
};

export const LABEL_STATUS_PEDIDO: Record<StatusPedido, string> = {
  aguardando_pagamento: 'Aguardando pagamento',
  pago: 'Pago — na fila',
  enviado_cozinha: 'Enviado à cozinha',
  preparando: 'Preparando',
  pronto: 'Pronto para servir',
  entregue: 'Entregue',
  cancelado: 'Cancelado',
};
